import { XApp } from '@core/utils';

export const createHostLinkGetter = (globalConfigNestedFields?: string[]) => (
  relativePath: string
) => {
  if (relativePath.includes('://')) {
    return relativePath;
  }

  return `${XApp.getApiUrlFromGlobal(globalConfigNestedFields)}${relativePath}`;
};
